export const Labels = {
  // Section
  RESULTS_PREVIEW: 'Results Preview',
  RECORDS_SUFFIX: 'Records',
  NO_DATA: 'No Data to Display',

  // Filters
  FILTER_CARRIER: 'Carrier',
  FILTER_POLICY_TYPE: 'Policy Type',
  FILTER_AGENCY: 'Agency',
  FILTER_TERM_DATE: 'Term Date',

  // Buttons
  PREVIEW: 'PREVIEW',
  CSV_EXPORT: 'CSV EXPORT',
  CLEAR: 'CLEAR',

  // Grid columns
  COL_ACCOUNT: 'Account #',
  COL_POLICY: 'Policy #',
  COL_CARRIER: 'Carrier',
  COL_POLICY_TYPE: 'Policy Type',
  COL_TERM: 'Term',
  COL_POLICY_PREMIUM: 'Policy Premium',
  COL_ESTIMATED_COMMISSION: 'Estimated Commission',
  COL_IMPORTED_PREMIUM: 'Imported Premium',
  COL_IMPORTED_COMMISSION: 'Imported Commission',
  COL_RECONCILED: 'Reconciled',
  COL_VARIANCE: 'Variance',
  COL_COMPENSATION: 'Compensation',
  COL_AGENCY: 'Agency',

  // CSV
  CSV_FILENAME: 'commission-reconciliation.csv',
}
